/* PawHaus Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile Nav ---- */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => mobileNav.classList.add('open'));
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));
  }

  /* ---- Quantity Selector ---- */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.quantity-selector').querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'plus') val = Math.min(val + 1, 99);
      if (this.dataset.action === 'minus') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });

  /* ---- Product Thumbnails ---- */
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ---- Variant Buttons ---- */
  document.querySelectorAll('.variant-options').forEach(group => {
    group.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
      });
    });
  });

  /* ---- Add to Cart Flash ---- */
  const addBtn = document.querySelector('.add-to-cart-btn');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      const orig = this.textContent;
      this.textContent = 'Added!';
      this.style.background = '#b5a48b';
      setTimeout(() => {
        this.textContent = orig;
        this.style.background = '';
      }, 1600);
    });
  }

  /* ---- Newsletter Form ---- */
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('.newsletter-input');
      const btn = this.querySelector('.btn');
      btn.textContent = 'Subscribed!';
      btn.style.background = '#b5a48b';
      input.value = '';
      setTimeout(() => {
        btn.textContent = 'Subscribe';
        btn.style.background = '';
      }, 3000);
    });
  }

  /* ---- Contact Form ---- */
  const contactForm = document.querySelector('.contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = this.querySelector('.btn');
      btn.textContent = 'Message Sent!';
      btn.style.background = '#b5a48b';
      setTimeout(() => {
        btn.textContent = 'Send Message';
        btn.style.background = '';
        this.reset();
      }, 3000);
    });
  }

  /* ---- Sticky Header shadow ---- */
  window.addEventListener('scroll', function () {
    const header = document.querySelector('.site-header');
    if (header) {
      header.style.boxShadow = window.scrollY > 10 ? '0 1px 20px rgba(0,0,0,0.07)' : '';
    }
  });

});
